import React from 'react';
import { connect } from 'react-redux';
import { pluralHelper, capitaliseFirstLetter } from '../../../../helpers/stringutils';
import { ISOCurrencyCovert } from '../../../../helpers/locationHelper';
import { numAccommodationNights } from '../../../../helpers/itineraryHelper'


const Pricebreakdown = (props) => {

    const { currentBooking:{iso_currency, tmsBookingId,  uuid, items, prices, passengers, itinerary, status }, visible } = props;
    const _uuid = uuid !== undefined ? uuid : "";
    const _tmsBookingId = tmsBookingId !== undefined ? tmsBookingId : null;
    const _items = items !== undefined ? items : []; 
    const _prices = prices !== undefined ? prices : "";
    const _itinerary = itinerary !== undefined ? itinerary : [];
    const _numPasseger = (passengers !== undefined) ? passengers.length : "";
    
    const _filterCity = _itinerary.filter(item => item.type === "city")
    const _pricePerStop = _filterCity.length ? _filterCity[0].price : 0;

    if(!visible) return null;

    return (
        <div className="itinerary-pricebreakdown round-corners">
            <div className="max-width-5 mx-auto">
                <div className="clearfix">
                    <div className="col col-12 px2">
                        <p className="bold uppercase margin-b-20">
                            <span className="black-text f-size-14">Price summary</span>
                            <span className="orange-text uppercase right f-size-14">{iso_currency}</span>
                        </p>
            
                        <p className="agent-portal-grey f-size-12 margin-b-20">Booking {_tmsBookingId !== null ? '' : 'Quote'} Ref: <span className="medium">{ _tmsBookingId !== null ? _tmsBookingId : _uuid }</span> </p>
                    </div>
                    
                    <div className="col col-12 px2"><div className="divider"></div></div>

                </div>

                {
                    _items.map((data, index) => {
                        return (
                            <div className="clearfix" key={index}>
                                <div className="col col-9 px2 margin-t-20 margin-b-20">
                                    <p className="black-text f-size-16 margin-b-10 medium">{capitaliseFirstLetter(data.name)}</p>
                                    { 
                                        data.type === "builder" ? 
                                        <>
                                            <p className="black-text f-size-12">{data.cityCount} stops (approx. {ISOCurrencyCovert(iso_currency).props.children}{parseFloat(_pricePerStop).toFixed(2)} per stop)</p>
                                            <p className="black-text f-size-12">{numAccommodationNights(itinerary)} nights accomodation included</p>
                                        </>
                                        :
                                        <>
                                        { data.nights !== null && <p className="black-text f-size-12">{data.nights + 1} days &amp; {data.nights} nights accomodation included</p>}
                                        </>
                                    }
                                </div>
                                <div className="col col-3 px2 margin-t-20 margin-b-20">
                                    <p className="black-text right f-size-14 margin-b-10 medium">{ISOCurrencyCovert(iso_currency).props.children}{parseFloat(data.price / _numPasseger).toFixed(2)}</p>
                                    
                                    {  data.type === "builder" && <p className="black-text right f-size-14 mt1 margin-b-10 medium">{ISOCurrencyCovert(iso_currency).props.children}{parseFloat(_prices.accommodationPerPassenger).toFixed(2)}</p>}

                                </div>
                                <div className="col col-12 px2"><div className="divider"></div></div>
                            </div>
                        )
                    })
                }


                <div className="clearfix">
                    <div className="col col-6 px2 margin-t-20 margin-b-10"><p className="black-text f-size-14 medium">Trip Total</p></div>
                    <div className="col col-6 px2 margin-t-20 margin-b-10"><p className="black-text right f-size-14 medium">{ISOCurrencyCovert(iso_currency).props.children}{parseFloat(_prices.totalPerPassenger).toFixed(2)}</p></div>
                </div>

                <div className="clearfix">
                    <div className="col col-6 px2 margin-b-10"><p className="black-text f-size-14 medium">Subtotal (x{_numPasseger} {pluralHelper('Adult', _numPasseger)})</p></div>
                    <div className="col col-6 px2 margin-b-10"><p className="black-text right f-size-14 medium">{ISOCurrencyCovert(iso_currency).props.children}{parseFloat(_prices.total).toFixed(2)}</p></div>
                </div>
                {
                    status === "confirmed" && (
                        <div className="clearfix">
                            <div className="col col-6 px2 margin-b-10"><p className="bold black-text f-size-14">Total Paid</p></div>
                            <div className="col col-6 px2 margin-b-10"><p className="bold black-text right f-size-14">{ISOCurrencyCovert(iso_currency).props.children}{parseFloat(_prices.paid).toFixed(2)}</p></div>
                        </div>
                    )
                }

                <div className="clearfix">
                    <div className="col col-6 px2"><p className="bold orange-text f-size-14">{status === "confirmed" ? 'Total Due' : 'Trip Price'} </p></div>
                    <div className="col col-6 px2">
                        <p className="bold orange-text right f-size-14">
                            { status !== "confirmed" && (`${ISOCurrencyCovert(iso_currency).props.children}${parseFloat(_prices.total).toFixed(2)}`) }
                            { status === "confirmed" && (`${ISOCurrencyCovert(iso_currency).props.children}${parseFloat(_prices.due).toFixed(2)}`) }
                        </p>
                    </div>
                </div>    

            </div>
        </div>            
    )
    

}


const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        meta:state.currentBooking.meta,
    }
}

export default connect(mapStateToProps, null)(Pricebreakdown);